import React from "react";
import { MainLayout } from "../MainLayout";
import { JournalSec2 } from "./JournalSec2";
import { Footer } from "../Footer";
import { ContactSec4 } from "../ContactUs/ContactSec4";

export const Journal = () => {
    return (
        <>
            <MainLayout
                bgImage={'url("https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Blog%20banner.webp")'}
                text1={"BLOGS"}
                text2={"Travel Tales & Insights"}
                // text3={" Insights"}
                button={true}
            />
            <JournalSec2 />
            <ContactSec4/>
            <Footer />
        </>
    )
}
